export default __webpack_public_path__ + "static/media/laser-teeth-whitening-716468_1920.2192fd79.jpg";